import { Injectable } from '@angular/core';
import * as mixpanel from 'mixpanel-browser';
import { Mixpanel } from 'mixpanel-browser';

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {

  get people(): Mixpanel.People {
    return mixpanel.people;
  }

  public identify(uniqueId: string): void {
    mixpanel.identify(uniqueId);
  }

  public register(properties: any = {}): void {
    mixpanel.register(properties);
  }

  public track(id: string, action: any = {}): void {
    mixpanel.track(id, action);
  }
}
